const demo_app = {
    notification: "Astuce : Créez d'abord un compte pour tester l'expérience de connexion.",
};
export default Object.freeze(demo_app);
